import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { GroupProviderSearchRequest } from 'src/app/services/models/provider/groupprovider.search.request.model'
import {Response} from 'src/app/services/models/response.model'
import { GroupProvider } from './models/provider/groupprovider.model';

@Injectable()
export class GroupProviderService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.groupprovider;
  }

  searchGroupProvider(seachdetail: GroupProviderSearchRequest): Observable<Response<GroupProvider[]>> {
    return this.post(`/SearchGroupProvider`, seachdetail, {})
    .map(result => new Response<GroupProvider[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }
}